export const INITIAL_DESTINATION_VALUES = [
  {
    desttxtConsignee: 0,
    descETA: null,
    destSoftWeight: 0,
    destSoftOks: 0,
    destMiscWeight: 0,
    destMiscOks: 0,
    destBookWeight: 0,
    destBookOks: 0,
    destFurn: 0,
    destOLI: 0,
    destname: '',
    destaddress1: '',
    destcity: '',
    deststate: '',
    destzip: '',
    destcountry: '',
    destcustref: '',
    seqVal: 0,
  },
];

export const INITIAL_ORIGIN_VALUES = [
  {
    orgtxtShipLocation: 0,
    orgSpotDate: '',
    orgETD: null,
    orgSoftWeight: 0,
    orgSoftOks: 0,
    orgMiscWeight: 0,
    orgMiscOks: 0,
    orgBookWeight: 0,
    orgBookOks: 0,
    orgFurn: 0,
    orgOLI: 0,
    orgname: '',
    orgaddress1: '',
    orgcity: '',
    orgstate: '',
    orgzip: '',
    orgcountry: '',
    orgcustref: '',
    seqVal: 0,
  },
];

export const INITIAL_PRODUCT_DETAILS = [
  {
    shipmentKey: 0,
    itemSequenceKey: 0,
    quantity: 0,
    unitMeasure: 'LB',
    productCode: '',
    productDescription: '',
    class: '',
    deliveryID: '',
    length: 0,
    height: 0,
    width: 0,
    dimUom: 'N',
    weight: 0,
    actualWeight: 0,
    weightUom: 'LB',
    cube: 0,
    billQty: 1,
    billQtyUom: 'LB',
    createdBy: '',
    stcDescription: '',
    hazmatUnNo: '',
    hazmat: '',
    poNumber: '',
    soNumber: '',
    reference1: '',
    palletLoadType: 'Non Stackable',
    gridOperation: 1,
    shipmentDetailsID: 0,
    className: '',
    unitMeasureName: '',
    weightUomName: '',
    dimUomName: '',
    billQtyUomName: '',
    crateNo: '',
    cartonQty: 0,
    cartonUOM: '',
    unitPrice: 0,
    nmfcNumber: '',
    hts: '',
    eccn: '',
    countryOfOrigin: '',
    palletPackageType: '',
    bookOks: 0,
    book: 0,
    soft: 0,
    softOks: 0,
    misc: 0,
    miscOKs: 0,
  },
];

export const INITIAL_ORG_INFO = [
  {
    shipmentKey: 0,
    originKey: 0,
    sequence: 1,
    legNumber: 0,
    stopType: '1',
    shipRecKey: 0,
    customerKey: 0,
    name: '',
    addr1: 'NS',
    addr2: '',
    city: 'NS',
    state: 'NS',
    zip: 'NS',
    countryCode: 'NS',
    searchId: '',
    createdBy: '',
    oldStopSequence: 0,
    portType: '',
    portRecKey: 0,
    gridOperation: 1,
    displaySequence: 1,
    shipmentOriginAdditionalInformation: {
      shipmentKey: 0,
      sequence: 1,
      carrierAppontmentShipDate: null,
      carrierActualShipDate: null,
      shipperRequestedDeliveryDate: null,
      carrierAppontmentDeliveryDate: null,
      carrierActualDeliveryDate: null,
      doorDockID: '',
      pickupDeliveryID: '',
      contactName: '',
      contactEmail: '',
      phone: '',
      createdBy: '',
      hoursOfOperation: '',
      appointmentType: '',
      gridOperation: 1,
      oldStopSequence: 0,
      displaySequence: 1,
      isResetNew: 0,
      uom: '',
      legMiles: 0,
      extension: '',
      dockNumber: '',
      taxId: '',
    },
    countryName: '',
    stateName: '',
    portName: '',
    isResetNew: 0,
    trailerNumber: '',
  },
];

export const INITIAL_DEST_INFO = [
  {
    shipmentKey: 0,
    destinationKey: 0,
    sequence: 99,
    legNumber: 0,
    stopType: '2',
    shipRecKey: 0,
    customerKey: 0,
    name: '',
    addr1: 'NS',
    addr2: '',
    city: 'NS',
    state: 'NS',
    zip: 'NS',
    countryCode: 'NS',
    searchId: '',
    createdBy: '',
    oldStopSequence: 0,
    portType: '',
    portRecKey: 0,
    gridOperation: 1,
    displaySequence: 99,
    shipmentDestinationAdditionalInformation: {
      shipmentKey: 0,
      sequence: 99,
      shipperRequestedShipDate: null,
      carrierAppontmentShipDate: null,
      carrierActualShipDate: null,
      shipperRequestedDeliveryDate: null,
      carrierAppontmentDeliveryDate: null,
      carrierActualDeliveryDate: null,
      doorDockID: '',
      pickupDeliveryID: '',
      contactName: '',
      contactEmail: '',
      phone: '',
      createdBy: '',
      hoursOfOperation: '',
      appointmentType: '',
      gridOperation: 1,
      oldStopSequence: 0,
      displaySequence: 99,
      isResetNew: 0,
      uom: '',
      legMiles: 0,
      extension: '',
      dockNumber: '',
      taxId: '',
    },
    countryName: '',
    stateName: '',
    portName: '',
    isResetNew: 0,
    trailerNumber: '',
  },
];

export const INITIAL_ORG = [
  {
    trailerMovementID: 0,
    spotDate: '',
    etd: null,
    trailerID: '',
    clothOKs: 0,
    miscOKs: 0,
    softWeight: 0,
    hardWeight: 0,
    furniturePieces: 0,
    otherLargeItems: 0,
    sendComplete: false,
    bookOks: 0,
    bookWeight: 0,
  },
];

export const excludedStatuses = ['PLN', 'BRK', 'ASN'];

export const DEFAULT_PAGE_NUMBER = 1;
export const DEFAULT_PAGE_SIZE = 10;

export const DEFAULT_PARAMS = {
  PageNumber: DEFAULT_PAGE_NUMBER,
  PageSize: DEFAULT_PAGE_SIZE,
};

export const TRANSACTION_TYPES = {
  Purchase: 0,
  PurchaseAdjustment: 1,
  Transfer: 2,
};
